// Invite prefill runs on every page load - including when a client returns to
// a form they'd already started, whose progress was restored from
// localStorage. Overwriting with the CRM's on-file info silently replaced
// things the client had just changed (e.g. a new address, seen live
// 2026-10-18), so prefill may only fill fields that are still empty.

function isBlank(value) {
  return value === undefined || value === null
    || (typeof value === 'string' && value.trim() === '')
    || (Array.isArray(value) && value.length === 0);
}

/** The entries of `incoming` whose field is still empty in `current`. */
export function fillBlanks(current, incoming) {
  return Object.fromEntries(Object.entries(incoming || {}).filter(([key]) => isBlank((current || {})[key])));
}
